export var Indexer;
(function (Indexer) {
    /**
     * Reindex item data on BE
     */
    let Reindex;
    (function (Reindex) {
        Reindex.path = 'indexer/reindex';
    })(Reindex = Indexer.Reindex || (Indexer.Reindex = {}));
})(Indexer || (Indexer = {}));
